import * as React from 'react';
import Select from 'react-select';
import { UilUser, UilCrosshairs } from '@iconscout/react-unicons';

import { MiniModal, MiniModalActions, MiniModalContent } from 'inca-ui';
import { AUDIENCE_RULE_TYPES } from '../../../../../interface/project.interface';
import { AudienceRule, QTYPES, QuestionSummary } from '@nexxt/common/types';
import { AUDIENCE_QTYPE } from '../../../../../constants/question';
import { getConfirmationBox } from '../../../../common/swal/Sweetalert';
import {
    alertMessage,
    titleHeader
} from '../../../../../constants/alertMessage';
import { dataTestid } from '../../../../../constants/dataTestid';

interface CustomScreenerModal {
    showCustomScreenerModal: boolean;
    screenerType: AUDIENCE_RULE_TYPES;
    customAudienceRules: AudienceRule[];
    questionList: QuestionSummary[];
    questionId: number | null;
    closeCustomScreenerModal: () => void;
    changePathToQuestions: () => void;
    onDone: (selectedQuestion: any, keyName?: AUDIENCE_RULE_TYPES) => void;
}

const CustomScreenerModal = (props: CustomScreenerModal) => {
    const [questionList, setQuestionList] = React.useState<QuestionSummary[]>(
        []
    );
    const [selectedQuestion, setSelectedQuestion] = React.useState<any>(null);

    const isBuiltInScreener =
        props.screenerType === AUDIENCE_RULE_TYPES.BUILT_IN_RULE ? true : false;

    const mappedQuestionList = (questions): QuestionSummary[] => {
        return questions
            .filter((q) => AUDIENCE_QTYPE.includes(q.type as QTYPES))
            .map((question, index) => {
                return {
                    id: question.id,
                    type: question.type,
                    questionId: question.id,
                    label: question.label || question.title || question.value,
                    value: question.value,

                    selectedRegion: question['selectedRegion'] || null,
                    questionTexts: question.questionTexts,
                    showNotApplicableOption:
                        question['showNotApplicableOption'],
                    notApplicableTexts: question['notApplicableTexts'],
                    options:
                        !isBuiltInScreener && question['options']?.length // for system metadata
                            ? mappedQuestionList(question['options'])
                            : null
                };
            });
    };

    const onQuestionChange = async (selectedQuestion: any) => {
        setSelectedQuestion(selectedQuestion);
    };

    const onDone = async () => {
        if (isBuiltInScreener) {
            props.onDone(selectedQuestion, AUDIENCE_RULE_TYPES.BUILT_IN_RULE);
        } else {
            try {
                const result = await getConfirmationBox({
                    message: alertMessage.CONFIRM_SWITCHING_TO_SCREENER,
                    showCloseButton: true,
                    confirmButtonColor: '',
                    title: titleHeader.SWITCH_QUESTION_TYPE
                });
                if (!result.value) {
                    return;
                }

                props.onDone(selectedQuestion);
            } catch (e) {}
        }

        props.closeCustomScreenerModal();
    };
    React.useEffect(() => {
        setQuestionList(mappedQuestionList(props.questionList));
        if (props.questionId) {
            const question = props.questionList.filter(
                (x) => x.id === props.questionId
            )[0];
            setSelectedQuestion({ ...question, questionId: props.questionId });
        }
    }, []);
    return (
        <div className="screener-modal">
            <MiniModal
                isOpen={props.showCustomScreenerModal}
                isBlurred={false}
                isClosable={true}
                onClose={props.closeCustomScreenerModal}
            >
                <MiniModalContent
                    header={
                        isBuiltInScreener
                            ? 'Built-in Targeting Options'
                            : 'Screener Questions'
                    }
                    body={
                        isBuiltInScreener
                            ? 'Add from the built-in targeting options to determine the types of participants that will be sent to your study.'
                            : 'Select questions from your study to turn them into custom screener questions to qualify and disqualify participants.'
                    }
                >
                    <div className="mb-4">
                        <Select
                            options={questionList}
                            value={selectedQuestion || null}
                            onChange={onQuestionChange}
                            placeholder="Select from available options"
                        />
                    </div>

                    {/* <div className="screener-modal--options">
                        {selectedQuestion && (
                            <div className="screener-modal--options--option new-screener">
                                {selectedQuestion.label}
                            </div>
                        )}
                        {props.customAudienceRules.map(
                            ({ selectedQuestion }) => (
                                <div
                                    className="screener-modal--options--option"
                                    key={selectedQuestion.questionId}
                                >
                                    {selectedQuestion.label}
                                </div>
                            )
                        )}
                    </div> */}
                    {!isBuiltInScreener && (
                        <p>
                            <span
                                className="q-redirect"
                                data-test={dataTestid.CUSTOM_SCREENER_REDIRECT}
                                onClick={props.changePathToQuestions}
                            >
                                Go to question builder
                            </span>
                            {` to add a new question that can be used as a custom
                            screener.`}
                        </p>
                    )}
                </MiniModalContent>
                <MiniModalActions>
                    <button
                        className="screener-modal--btn"
                        style={{
                            marginRight: '10px'
                        }}
                        onClick={props.closeCustomScreenerModal}
                    >
                        Cancel
                    </button>
                    <button
                        className="screener-modal--btn--done"
                        data-test={dataTestid.MODAL_DONE_BTN}
                        onClick={onDone}
                        disabled={!selectedQuestion}
                    >
                        Done
                    </button>
                </MiniModalActions>
            </MiniModal>
        </div>
    );
};

export default CustomScreenerModal;
